import { validateProductPack } from '../../../../utils/productPack';
import { MAX_INVENTORY_QUANTITY } from '../../../../utils/inventoryInputs';
import { stockQuantitiesChanged } from '../../../../utils/stockQuantities';
import { INITIAL_SELECTED_PRODUCT, PRODUCT_STATES } from '../constants';
import { BASE_URL } from '../../../../shared/constants';

export const formatMoney = value => `${Number(value || 0).toLocaleString('uk-UA')} грн`;
export const productStateLabel = state =>
  PRODUCT_STATES.find(item => item.value === state)?.label || state || 'Без статусу';
export const imageName = image =>
  typeof image === 'string'
    ? image
    : image?.awsName || image?.imagePath || image?.path || image?.src;
export const productImageUrl = name =>
  `${BASE_URL}/api/v1/product/image/${encodeURIComponent(name)}`;
export const dateInputValue = date => {
  if (Array.isArray(date))
    return date
      .slice(0, 3)
      .map((value, i) => (i ? String(value).padStart(2, '0') : value))
      .join('-');
  return typeof date === 'string' ? date.split('T')[0] : '';
};
export const createProductDraft = (product = {}) => ({
  ...INITIAL_SELECTED_PRODUCT,
  ...product,
  productCode: product.code ?? product.productCode ?? '',
  state: product.state?.databaseValue || product.state || 'ACTIVE',
  quantity: product.quantity ?? 0,
  price: product.price ?? 0,
  discount: product.discount ?? 0,
  originalQuantity: product.quantity ?? 0,
  originalState: product.state?.databaseValue || product.state || 'ACTIVE',
  quantityChangeReason: '',
  expectedArrivalDate: dateInputValue(product.expectedArrivalDate),
  categoryIds: product.categoryIds || (product.categories || []).map(category => category.id),
  images: (product.images || []).map(imageName).filter(Boolean),
});
export const readNumber = value => {
  if (value == null || String(value).trim() === '') return NaN;
  const text = String(value)
    .trim()
    .replace(',', '.');
  return /^\d+(?:\.\d+)?$/.test(text) ? Number(text) : NaN;
};
export const isIntegerAmount = value =>
  Number.isInteger(readNumber(value)) && readNumber(value) <= MAX_INVENTORY_QUANTITY;
export const validateProductDraft = draft => {
  const packError = validateProductPack(draft);
  if (packError) return packError;
  if (!draft.name?.trim()) return 'Вкажіть назву товару';
  if (!draft.productCode?.trim()) return 'Вкажіть артикул товару';
  if (!PRODUCT_STATES.some(item => item.value && item.value === draft.state))
    return 'Оберіть статус товару';
  if (!isIntegerAmount(draft.price)) return 'Ціна має бути цілим невід’ємним числом';
  if (!isIntegerAmount(draft.quantity)) return 'Кількість має бути цілим невід’ємним числом';
  const discount = readNumber(draft.discount);
  if (!Number.isInteger(discount) || discount > 100)
    return 'Знижка має бути цілим числом від 0 до 100';
  if (
    draft.id &&
    stockQuantitiesChanged(draft) &&
    !draft.quantityChangeReason?.trim()
  )
    return 'Вкажіть причину зміни кількості';
  for (const key of ['priceInPounds', 'priceInUSD', 'priceInEuro', 'purchasePrice']) {
    if (draft[key] != null && draft[key] !== '' && !Number.isFinite(readNumber(draft[key])))
      return 'Перевірте закупівельну ціну та ціни у валюті';
  }
  return '';
};
export const toProductPayload = draft => ({
  ...draft,
  name: draft.name.trim(),
  productCode: draft.productCode.trim(),
  quantityChangeReason: draft.quantityChangeReason.trim(),
  ...Object.fromEntries(
    [
      'price',
      'quantity',
      'discount',
      'priceInPounds',
      'priceInUSD',
      'priceInEuro',
      'purchasePrice',
    ].map(key => [key, draft[key] === '' || draft[key] == null ? null : readNumber(draft[key])]),
  ),
});
export const toggleValue = (values, value) =>
  values.includes(value) ? values.filter(item => item !== value) : [...values, value];
